import { useRoll } from '../../../hooks/useRoll';
import type { InitiativeRollButtonProps, SendFn } from './types';

/**
 * Roll Initiative button — placed next to CombatTab initiative Stepper.
 * Calls useRoll().rollInitiative() (server rolls 1d20 + DEX mod + bonuses).
 * Stepper wiring for `data.combat.initiative` preserved separately.
 */
export function InitiativeRollButton({
  data,
  sheetId,
  send,
  onMessage,
}: InitiativeRollButtonProps) {
  const noopSend: SendFn = () => {};
  // onMessage wires the roll:result subscription so useRoll cancels its 5s
  // timeout when the server confirms — otherwise the toast always fires.
  const roll = useRoll(sheetId ?? '', data, send ?? noopSend, onMessage);
  const disabled = !send || !sheetId;

  return (
    <button
      type="button"
      onClick={() => roll.rollInitiative()}
      disabled={disabled}
      title="Бросок инициативы (1d20 + DEX)"
      className="text-label" style={{
        padding: '4px 10px',
        fontFamily: 'JetBrains Mono, monospace',
        fontWeight: 500,
        letterSpacing: '0.08em',
        textTransform: 'uppercase',
        border: '1px solid var(--paper-rule)',
        background: disabled ? 'transparent' : 'var(--paper-bg-2)',
        color: disabled ? 'var(--paper-ink-2)' : 'var(--paper-ink)',
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.5 : 1,
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
      }}
    >
      🎲 Бросок
    </button>
  );
}
